import Model from 'flarum/common/Model';

export default class DarkStory extends Model {
  slug = Model.attribute('slug');
  translation = Model.attribute('translation');
  title = Model.attribute('title');
  date = Model.attribute('date');
  year = Model.attribute('year');
  kind = Model.attribute('kind');
  clubSlugs = Model.attribute('clubSlugs');
  place = Model.attribute('place');
  summary = Model.attribute('summary');
  weight = Model.attribute('weight');
  isPublished = Model.attribute('isPublished');
  bodyHtml = Model.attribute('bodyHtml');
  timeline = Model.attribute('timeline');
  quotes = Model.attribute('quotes');
  sources = Model.attribute('sources');
  images = Model.attribute('images');

  searchText() {
    return [this.title(), this.place(), this.summary()].filter(Boolean).join(' ').toLowerCase();
  }
}
